import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../shared/auth/auth.service';
import { select, Store } from '@ngrx/store';
import * as fromRoot from '../../store/reducers';
import { getError, getLoading, getSelected } from '../../store/reducers/user';
import { AppUser } from '../../models/user.model';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss']
})

export class LoginPageComponent implements OnInit, OnDestroy {

  @ViewChild('f') loginForm: NgForm;
  private user: AppUser = <AppUser>{};
  private subscriber: any;
  // locker
  lockForm: boolean;
  error: any;

  constructor(private router: Router,
              private route: ActivatedRoute,
              private authService: AuthService,
              private store: Store<fromRoot.AppState>) { }

  ngOnInit() {
    // logout
    this.authService.logout();
    // set subscriber
    this.subscriber = this.store.pipe(select(fromRoot.selectUserState()))
      .subscribe((state: any) => {
        this.user = getSelected(state);
        this.lockForm = getLoading(state);
        this.error = getError(state);
      });
  }

  ngOnDestroy() {
    this.subscriber.unsubscribe();
  }

  // On submit button click
  onSubmit() {
    this.lockForm = true;
    this.authService.authenticate(this.loginForm.controls['iLogin'].value, this.loginForm.controls['iPass'].value);
    this.loginForm.reset();
  }

  // On Forgot password link click
  onForgotPassword() {
    // this.router.navigate(['forgotpassword'], { relativeTo: this.route.parent });
  }

  // On registration link click
  onRegister() {
    // this.router.navigate(['register'], { relativeTo: this.route.parent });
  }
}
